var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDiscover = function SvgDiscover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 503,
    fill: "currentColor",
    viewBox: "0 0 800 503",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.402 30.084h687.196c14.157 0 25.633 11.223 25.633 25.074v220.534s-77.54 51.221-167.378 86.618c-142.684 64.491-349.374 110.006-363.524 110.006H56.402c-14.157 0-25.633-11.222-25.633-25.074V55.159c0-13.846 11.483-25.075 25.633-25.075M0 55.158v392.084C0 477.707 25.25 502.4 56.402 502.4h687.196c31.144 0 56.402-24.699 56.402-55.158V55.159C800 24.693 774.75 0 743.598 0H56.402C25.258 0 0 24.7 0 55.159"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiscover);
export default ForwardRef;